const _isMac = typeof navigator !== 'undefined' && navigator.userAgent.includes('Mac');
export const isMacOs = () => _isMac;
export const isPlatformModifierKey = e => _isMac ? e.metaKey : e.ctrlKey;